
import { Component, Prop, Vue } from 'vue-property-decorator'
import Tab from 'vue-tabs-component/src/components/Tab.vue'
import Tabs from 'vue-tabs-component/src/components/Tabs.vue'
import ItemProperties from './ItemProperties.vue'

@Component({
  components: { Tabs, Tab, ItemProperties },
})
export default class ItemSpecification extends Vue {
  @Prop({ default: {} }) item: Object
}
